import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

/* ───── JS DEPENDENCIES (đúng thứ tự) ───── */
// import 'jquery'                     // 1. jQuery
// import 'bootstrap'                  // 2. Bootstrap JS (kéo Popper sẵn)



/* ───── CSS (để Bootstrap ghi đè AdminLTE cho phần b-table, b-btn) ───── */
import '@fortawesome/fontawesome-free/css/all.min.css'


// import 'jquery/src/jquery.js';
// import 'popper.js/dist/popper.min.js';
// import 'bootstrap/dist/js/bootstrap.min.js';

// Xóa hai dòng này
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'




/* ───── Vue Plugins ───── */
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

/* ───── Component tự tạo ───── */
import RawLoader from '@/components/ComRawLoader.vue'
Vue.component('raw-loader', RawLoader)


import FileUpload from '@/components/Com/FileUpload.vue';
Vue.component('FileUpload',FileUpload);

/* ───── Component tự tạo ───── */
import ComPaging from '@/components/Com/ComPaging.vue';
Vue.component('ComPaging',ComPaging);



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
